import React, { Component } from "react";
import { fire, auth } from "../../../firebase/index";
import LocalizedStrings from "react-localization";

let localizationStrings = new LocalizedStrings({
  en: {
    reply1:
      "Our affiliated company filed a PCT patent in 2010 covering over 100 countries, WIPO published the patent in 2012, subsequently it was fully granted by US patent and trademark office (USPTO) and the legal intellectual property right is owned by DIGIPAS TECHNOLOGIES INC. Since, we have extended the utility patent to many countries around the world. There are more granted and pending patents of ours in the domain of smartlocks forming a strong IP portfolio and serves as the basis for our international sales distributorship and licensing agreements. For more information on Patents and Intellectual Property, ",
    reply2: "click here",
    back: "Back",
  },
  ja: {
    reply1:
      "当社の関連会社は 2010 年に 100 か国以上をカバーする PCT 特許を出願し、2012 年に WIPO が特許を公開し、その後米国特許商標庁 (USPTO) によって完全に認可され、法的知的財産権は DIGIPAS TECHNOLOGIES INC が所有しています。当社は実用特許を世界中の多くの国に拡張しました。スマートロックの分野では、当社の取得済みおよび出願中の特許がさらに多くあり、強力な IP ポートフォリオを形成しており、当社の国際的な販売代理店およびライセンス契約の基礎となっています。特許および知的財産について詳しくは、",
    reply2: "ここをクリック",
    back: "戻る",
  },
  es: {
    reply1:
      "Nuestra empresa afiliada presentó una patente PCT en 2010 que abarca más de 100 países, la OMPI publicó la patente en 2012, posteriormente fue concedida en su totalidad por la Oficina de Patentes y Marcas de US (USPTO) y el derecho de propiedad intelectual legal es propiedad de DIGIPAS TECHNOLOGIES INC. Desde entonces, Hemos extendido la patente de utilidad a muchos países alrededor del mundo. Hay más patentes nuestras concedidas y pendientes en el ámbito de las candados inteligentes que forman una sólida cartera de propiedad intelectual y sirven como base para nuestros acuerdos de licencia y distribución de ventas internacionales. Para más información sobre Patentes y Propiedad Intelectual,",
    reply2: "haga clic aquí",
    back: "Atrás",
  },
});

class Q20_component extends Component {
  constructor(props) {
    super(props);

    this.state = {
      triggerValue: "0",
      clicked: false,
      language: "en",
    };
  }

  componentDidMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          localizationStrings.setLanguage(snapshot.val());
          this.setState({ language: snapshot.val() });
        });
    }
  }

  handleButtonClick2 = () => {
    if (!this.state.clicked) {
      this.setState({ triggerValue: "cancel", clicked: true }, () => {
        this.props.triggerNextStep({
          value: "cancel",
          trigger: "cancel",
        });
      });
    }
  };

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    const buttonStyle = {
      marginTop: "10px",
      width: "215px",
      backgroundColor: "#FFC500",
      color: "black",
      borderRadius: "25px",
      textAlign: "center",
      padding: "10px 10px",
      cursor: "pointer",
      transition: "background-color 0.3s",
      border: "none",
    };

    const buttonHoverStyle = {
      color: "white",
      backgroundColor: "#EF6C00",
    };

    const { triggerValue, clicked } = this.state;

    return (
      <div>
        {localizationStrings.reply1}
        <a
          href="https://www.egeetouch.com/about/patent-ip"
          target="_blank"
          style={{ textDecoration: "underline", color: "black" }}
        >
          {localizationStrings.reply2}
        </a>
        {this.state.language === "ja" ? "。" : "."}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            margin: "12px 0",
          }}
        >
          <button
            style={{
              ...buttonStyle,
              ...(triggerValue === "cancel" && buttonHoverStyle),
            }}
            onMouseEnter={() => this.setState({ isButtonHovered: true })}
            onMouseLeave={() => this.setState({ isButtonHovered: false })}
            onClick={this.handleButtonClick2}
            disabled={clicked}
          >
            {localizationStrings.back}
          </button>
        </div>
      </div>
    );
  }
}

export default Q20_component;
